import { Banner } from "@/components/banner";
import { PopUp } from "@/components/popUp";
import { SNS } from "@/components/sns";
import { VimeoPlayer } from "@/components/vimeoPlayer";
import {
    AboutIntro,
    AsideBanner,
    Attractions,
    DateSearchBar,
    PhotoFeed,
    RoomPreview,
    SpecialPreview,
} from "@/domains/components";
import { useBookingRecoilValue, useVimeoValue } from "@/shared/client";
import { MEDIA } from "@/styles/common";
import { createDate, getDefaultParameters } from "@/utils";
import { Box, Center, Spinner, Text } from "@chakra-ui/react";
import { useGetCommon, useGetPopUp, type MainInfoResponse, type PopUpResponse } from "@shared/server";
import dayjs from "dayjs";

export const Home = () => {
    const { data } = useGetCommon<MainInfoResponse>({ section: "main" });
    const { data: popUpData } = useGetPopUp<PopUpResponse>();
    const { isTablet, isMobile } = MEDIA();
    const bookingEngine = useBookingRecoilValue();
    const { idx } = getDefaultParameters();
    const vimeoValue = useVimeoValue();
    const { id } = vimeoValue;

    return data ? (
        <Box w="100%">
            {idx === "2017" && (
                <>
                    <VimeoPlayer id={id} />
                    <SNS />
                </>
            )}
            {popUpData && (
                <Center
                    position="absolute"
                    top={isMobile ? "108px" : "144px"}
                    left={isTablet ? "24px" : "auto"}
                    right={isTablet ? "auto" : "80px"}
                    zIndex="9999"
                    gap={isMobile ? "36px" : "24px"}
                    flexDir={isTablet ? "column" : "row"}
                >
                    {popUpData.currentPopups.map((currentPopUp) => {
                        const {
                            fromTo: { endDate },
                        } = currentPopUp;
                        const { currentObj } = createDate();
                        const isExpired = currentObj.valueOf() < dayjs(endDate).valueOf();

                        return isExpired && <PopUp key={currentPopUp.postIdx} currentPopUp={currentPopUp} />;
                    })}
                </Center>
            )}
            <Box position="relative">
                <Banner imgList={data.imgList} catchPraise={data.catchPraise} />
                {!bookingEngine.isGoogleBE && <DateSearchBar isSubMenu />}
            </Box>
            <AboutIntro />
            <RoomPreview />
            <SpecialPreview title={data.catchPraise.main.secondLine} />
            <AsideBanner isFullImg />
            <PhotoFeed />
            <Attractions />
        </Box>
    ) : (
        <Center h="100vh" columnGap="8px">
            <Text>LOADING</Text>
            <Spinner />
        </Center>
    );
};
